import Athletes from './container'

export default Athletes
